import React from 'react';
import { Widget } from '@typeform/embed-react';

import * as styles from './styles.module.scss';

const Wizard = () => <Widget id="Zs4oaxmg" className={styles.container} />;

export default Wizard;
